export default function TechCard({ icon: Icon, title, description }) {
  return (
    <div className="group rounded-tile-sm bg-site-surface p-6 shadow-sm ring-1 ring-site-hairline transition-all duration-300 hover:-translate-y-1 hover:shadow-lg sm:p-8">
      <span className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-omnyx-teal to-omnyx-cyan shadow-glow-teal transition-transform duration-300 group-hover:scale-110">
        <Icon className="h-6 w-6 text-white" aria-hidden="true" />
      </span>
      <h3 className="font-heading text-lg font-bold text-site-ink">{title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-site-muted">{description}</p>
    </div>
  );
}
